import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=9913e506"
import script from "./CouponModal.vue?vue&type=script&lang=ts"
export * from "./CouponModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports